import Oraganizations from "../Containers/Oraganizations/Oraganizations";
import AddOraganization from "../Containers/Oraganizations/AddOraganization";
import OraganizationDetails from "../Containers/Oraganizations/OraganizationDetails";
import Documentation from "../Containers/carrier/Documentation";
import Review from "../Containers/carrier/Review";
import Truck from "../Containers/carrier/Truck";
import Orders from "../Containers/carrier/Orders";
import CarrierOrderdetails from "../Containers/carrier/Orderdetails";
import Drivers from "../Containers/carrier/Drivers";
import Driverform from "../Containers/carrier/Driverform";
import Carriersettings from "../Containers/carrier/Carriersettings";
import Carrierusersettings from "../Containers/carrier/Settings";
import Signup from "../Components/Signup";
import Products from "../Containers/admin/Products";
import Loads from "../Containers/admin/Loads";
import customerSignup from "../Containers/customer/customerSignup";
import driverSignup from "../Containers/customer/driverSignup";
import customerDocumentation from "../Containers/customer/customerDocumentation";
import customerLocations from "../Containers/customer/customerLocations";
import Stones from "../Containers/customer/stones";
import Customers from "../Containers/admin/Customers";
import CustomerDetails from "../Containers/admin/CustomerDetails";
import AddProduct from "../Containers/admin/AddProduct";
import AddCustomer from "../Containers/admin/AddCustomer";
import Carriers from "../Containers/admin/Carriers";
import CarrierDetails from "../Containers/admin/CarrierDetails";
import AddCarrier from "../Containers/admin/AddCarrier";
import Stonedetails from "../Containers/customer/stonedetails";
import LoadDetails from "../Containers/admin/LoadDetails";
import AddLoad from "../Containers/admin/AddLoad";
import Requestquote from "../Containers/customer/requestquote";
import Finishorder from "../Containers/customer/finishorder";
import Editorder from "../Containers/customer/editOrder";
import AdminSettings from "../Containers/admin/Settings";
import Orderconfirm from "../Containers/customer/orderconfirm";
import Customersettings from "../Containers/customer/customersettings";
import editDocumentation from "../Containers/customer/editdocuments";
import AddLocation from "../Containers/admin/AddLocation";
import StonesOrders from "../Containers/customer/orders";
import OrderDetails from "../Containers/customer/OrderDetails";
import ProfileSettings from "../Containers/admin/ProfileSettings";
import AddUser from "../Containers/admin/AddUser";
import EditDocuments from "../Containers/carrier/EditDocuments";
import AdminNotifications from "../Containers/admin/AdminNotifications";
import ForgotPassword from "../Containers/ForgotPassword";
import ConfirmForgotPassword from "../Containers/ConfirmForgotPassword";
import DriverDetails from "../Containers/driver/DriverDetails";
import OrderList from "../Containers/driver/OrderList";
import CustomerProdcts from "../Containers/customer/customerProducts";
import Customer from "../Containers/carrier/Customer";
import CustomerNotifications from "../Containers/admin/CustomerNotifications";
import CarrierNotifications from "../Containers/admin/CarrierNotifications";
import DriverNotifications from "../Containers/admin/DriverNotifications";

const AppRoutes = [
  {
    key: "001",
    exact: true,
    path: "/app/oraganizations",
    name: "Oraganizations",
    component: Oraganizations,
  },
  {
    key: "002",
    exact: true,
    path: "/app/add_oraganization",
    name: "AddOraganization",
    component: AddOraganization,
  },
  {
    key: "003",
    exact: true,
    path: "/app/oraganization_details/:id",
    name: "OraganizationDetails",
    component: OraganizationDetails,
  },
  {
    key: "004",
    exact: true,
    path: "/carrier_app/documentation",
    name: "Documentation",
    component: Documentation,
  },
  {
    key: "005",
    exact: true,
    path: "/carrier_app/review",
    name: "Review",
    component: Review,
  },
  {
    key: "006",
    exact: true,
    path: "/carrier_app/truck",
    name: "Truck",
    component: Truck,
  },
  {
    key: "007",
    exact: true,
    path: "/carrier_app/myOrders",
    name: "Orders",
    component: Orders,
  },
  {
    key: "055",
    exact: true,
    path: "/carrier_app/allOrders",
    name: "Orders",
    component: Orders,
  },
  // {
  //     key: '008', exact: true, path: '/carrier_app/orders/orderdetails/:id', name: 'Orderdetails', component: CarrierOrderdetails,
  // },
  {
    key: "008",
    exact: true,
    path: "/carrier_app/allOrders/orderdetails/:id",
    name: "Orderdetails",
    component: CarrierOrderdetails,
  },
  {
    key: "009",
    exact: true,
    path: "/carrier_app/drivers",
    name: "Drivers",
    component: Drivers,
  },
  {
    key: "010",
    exact: true,
    path: "/carrier_app/drivers/driverform/:id",
    name: "Driverform",
    component: Driverform,
  },
  {
    key: "056",
    exact: true,
    path: "/carrier_app/drivers/driverform",
    name: "Driverform",
    component: Driverform,
  },
  {
    key: "011",
    exact: true,
    path: "/carrier_app/carriersettings",
    name: "Carriersettings",
    component: Carriersettings,
  },
  {
    key: "012",
    exact: true,
    path: "/carrier_login/Signup",
    name: "Carrier Signup",
    component: Signup,
  },
  {
    key: "014",
    exact: true,
    path: "/app/products",
    name: "Products",
    component: Products,
  },
  {
    key: "015",
    exact: true,
    path: "/app/loads",
    name: "Loads",
    component: Loads,
  },
  {
    key: "016",
    exact: true,
    path: "/app/customersignup",
    name: "customerSignup",
    component: customerSignup,
  },
  {
    key: "017",
    exact: true,
    path: "/app/customerdocumentation",
    name: "customerDocumentation",
    component: customerDocumentation,
  },
  {
    key: "018",
    exact: true,
    path: "/app/customerlocations",
    name: "customerLocations",
    component: customerLocations,
  },
  {
    key: "019",
    exact: true,
    path: "/app/stones",
    name: "Stones",
    component: Stones,
  },
  {
    key: "020",
    exact: true,
    path: "/app/customers",
    name: "Customers",
    component: Customers,
  },
  {
    key: "021",
    exact: true,
    path: "/app/customers/customerdetails/:id",
    name: "CustomerDetails",
    component: CustomerDetails,
  },
  {
    key: "022",
    exact: true,
    path: "/app/products/addproduct",
    name: "AddProduct",
    component: AddProduct,
  },

  {
    key: "023",
    exact: true,
    path: "/app/addcustomer",
    name: "AddCustomer",
    component: AddCustomer,
  },
  {
    key: "024",
    exact: true,
    path: "/app/carriers",
    name: "Carriers",
    component: Carriers,
  },
  {
    key: "025",
    exact: true,
    path: "/app/carriers/carrierdetails/:id",
    name: "CarrierDetails",
    component: CarrierDetails,
  },
  {
    key: "026",
    exact: true,
    path: "/app/addcarrier",
    name: "AddCarrier",
    component: AddCarrier,
  },
  {
    key: "027",
    exact: true,
    path: "/app/stones/stonedetails/:id",
    name: "Stonedetails",
    component: Stonedetails,
  },
  {
    key: "028",
    exact: true,
    path: "/app/loads/loaddetails/:id",
    name: "LoadDetails",
    component: LoadDetails,
  },
  {
    key: "057",
    exact: true,
    path: "/app/loads/addload",
    name: "AddLoad",
    component: AddLoad,
  },
  {
    key: "029",
    exact: true,
    path: "/app/requestquote",
    name: "Requestquote",
    component: Requestquote,
  },
  {
    key: "030",
    exact: true,
    path: "/app/stones/finishorder",
    name: "Finishorder",
    component: Finishorder,
  },
  {
    key: "031",
    exact: true,
    path: "/app/settings",
    name: "AdminSettings",
    component: AdminSettings,
  },
  {
    key: "032",
    exact: true,
    path: "/app/orderconfirm/:id",
    name: "Orderconfirm",
    component: Orderconfirm,
  },
  {
    key: "033",
    exact: true,
    path: "/app/customersettings",
    name: "Customersettings",
    component: Customersettings,
  },
  {
    key: "034",
    exact: true,
    path: "/app/editdocuments",
    name: "editDocumentation",
    component: editDocumentation,
  },
  {
    key: "035",
    exact: true,
    path: "/app/settings/addlocation",
    name: "AddLocation",
    component: AddLocation,
  },
  {
    key: "036",
    exact: true,
    path: "/app/products/editproduct/:id",
    name: "ProductEdit",
    component: AddProduct,
  },
  {
    key: "037",
    exact: true,
    path: "/app/orders",
    name: "StonesOrders",
    component: StonesOrders,
  },
  {
    key: "038",
    exact: true,
    path: "/app/orders/orderdetails/:id",
    name: "OrderDetails",
    component: OrderDetails,
  },
  {
    key: "039",
    exact: true,
    path: "/app/profilesettings",
    name: "ProfileSettings",
    component: ProfileSettings,
  },
  {
    key: "040",
    exact: true,
    path: "/app/settings/adduser",
    name: "AddUser",
    component: AddUser,
  },
  {
    key: "041",
    exact: true,
    path: "/carrier_app/editdocuments",
    name: "EditDocuments",
    component: EditDocuments,
  },
  {
    key: "042",
    exact: true,
    path: "/app/adminnotifications",
    name: "AdminNotifications",
    component: AdminNotifications,
  },
  {
    key: "043",
    exact: true,
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    key: "044",
    exact: true,
    path: "/confirm_forgot_password",
    name: "ConfirmForgotPassword",
    component: ConfirmForgotPassword,
  },
  {
    key: "045",
    exact: true,
    path: "/app/stones/finishorder/:id",
    name: "OrderEdit",
    component: Finishorder,
  },
  {
    key: "046",
    exact: true,
    path: "/app/stones/editorder/:id",
    name: "Editorder",
    component: Editorder,
  },
  {
    key: "047",
    exact: true,
    path: "/carrier_app/myOrders/orderdetails/:id",
    name: "Orderdetails",
    component: CarrierOrderdetails,
  },
  {
    key: "048",
    exact: true,
    path: "/app/driver/todo",
    name: "todo",
    component: OrderList,
  },
  {
    key: "049",
    exact: true,
    path: "/app/driver/done",
    name: "done",
    component: OrderList,
  },
  {
    key: "050",
    exact: true,
    path: "/app/driver/todo/:id",
    name: "Driverdetails",
    component: DriverDetails,
  },
  {
    key: "051",
    exact: true,
    path: "/app/driver/done/:id",
    name: "Driverdetails",
    component: DriverDetails,
  },
  {
    key: "058",
    exact: true,
    path: "/app/customerProducts",
    name: "Customer Products",
    component: CustomerProdcts,
  },
  {
    key: "052",
    exact: true,
    path: "/app/driversignup",
    name: "driverSignup",
    component: driverSignup,
  },
  {
    key: "053",
    exact: true,
    path: "/carrier_app/settings",
    name: "CarrierSettings",
    component: Carrierusersettings,
  },
  {
    key: "054",
    exact: true,
    path: "/customer/settings",
    name: "Drivers",
    component: Customer,
  },
  {
    key: "055",
    exact: true,
    path: "/app/carrierNotifications",
    name: "CarrierNotifications",
    component: CarrierNotifications,
  },
  {
    key: "056",
    exact: true,
    path: "/app/customerNotifications",
    name: "CustomerNotifications",
    component: CustomerNotifications,
  },
  {
    key: "057",
    exact: true,
    path: "/app/driverNotifications",
    name: "DriverNotifications ",
    component: DriverNotifications,
  },
];
export default AppRoutes;
